import Header from "./Header";
import Footer from "./Footer";
import { Link } from "react-router-dom";
import React, { useState } from "react";
import { FaEye, FaEyeSlash } from "react-icons/fa";
import { useNavigate } from "react-router-dom";

function RegisterPage() {
  
const navigate = useNavigate();
  const [fname, setFname] = useState("");
const [lname, setLname] = useState("");
const [email, setEmail] = useState("");
const [phone, setPhone] = useState("");
const [password, setPassword] = useState("");
const [cpassword, setCpassword] = useState("");
const [loading, setLoading] = useState(false);
const [showPassword, setShowPassword] = useState(false);
const [showConfirmPassword, setShowConfirmPassword] = useState(false);
const handleRegister = async (e) => {
  e.preventDefault();

  if (!fname || !lname || !email || !phone || !password || !cpassword) {
    alert("Please fill all fields");
    return;
  }

  if (password !== cpassword) {
    alert("Passwords do not match");
    return;
  }

  try {
    setLoading(true);

    const response = await fetch(
      "https://aethearia.store/superadmin/api/register",
      {
        method: "POST",
        // headers: {
        //   "Content-Type": "application/json",
        // },
        body: JSON.stringify({
          fname,
          lname,
          email,
          phone,
          password,
          cpassword,
        }),
      }
    );

    const data = await response.json();

    if (data.status) {
      alert("Account created successfully!");
      // optional redirect
      navigate("/login");
    } else {
      alert(data.message || "Registration failed");
    }
  } catch (err) {
    console.log(err);
    alert("Something went wrong");
  } finally {
    setLoading(false);
  }
};
  return (
    <>
      <style>{`

      .register-page{
        min-height:100vh;
        padding-top:120px;
        overflow:hidden;
      }

      .register-container{
        max-width:1300px;
        margin:auto;
        padding:40px 30px 80px;
        display:grid;
        grid-template-columns:1fr 520px;
        gap:50px;
        align-items:center;
      }

      /* LEFT IMAGE */
      .register-image{
        position:relative;
        overflow:hidden;
        border-radius:2px;
      }

      .register-image img{
        width:100%;
        height:760px;
        object-fit:cover;
        display:block;
        transition:transform 1.2s ease;
      }

      .register-image:hover img{
        transform:scale(1.04);
      }

      .image-overlay{
        position:absolute;
        inset:0;
        background:
        linear-gradient(
          to top,
          rgba(0,0,0,.35),
          rgba(0,0,0,.05)
        );
      }

      .image-text{
        position:absolute;
        left:45px;
        bottom:45px;
        color:#fff;
        z-index:2;
      }

      .image-text span{
        display:block;
        font-size:14px;
        letter-spacing:1px;
        margin-bottom:14px;
        opacity:.9;
      }

      .image-text h2{
        margin:0;
        font-size:30px;
        line-height:1.05;
        font-weight:400;
          font-family: Assistant, sans-serif;

      }

      /* FORM CARD */
      .register-card{
        border:1px solid #ddd2c2;
        padding:55px 48px;
      }

      .register-top{
        margin-bottom:35px;
      }

      .register-top span{
        font-size:14px;
        letter-spacing:1px;
        color:#9a8365;
      }

      .register-top h1{
        margin:14px 0 10px;
        font-size:30px;
        font-weight:400;
        color:#4c144e;
          font-family: Assistant, sans-serif;

      }

      .register-top p{
        margin:0;
        color:#6f6253;
        font-size:14px;
      }

      /* FORM */
      .register-form{
        display:flex;
        flex-direction:column;
      }

      .double-input{
        display:grid;
        grid-template-columns:1fr 1fr;
        gap:14px;
      }

      .register-input{
        width:100%;
        height:46px;
        border:1px solid #d8ccbc;
        background:#fff;
        padding:0 18px;
        margin-bottom:16px;
        font-size:14px;
        color:#2d241a;
        box-sizing:border-box;
        transition:.3s ease;
        border-radius:5px;
      }

      .register-input:focus{
        outline:none;
        border-color:#9f8561;
        box-shadow:0 0 0 3px rgba(159,133,97,.08);
      }

      .register-btn{
        width:40%;
        height:38px;
        border:none;
        background:#4c144e;
        color:#fff;
        font-size:14px;
        letter-spacing:2px;
        cursor:pointer;
        border-radius:5px;
        margin-top:10px;
        transition:.35s ease;
      }

      .register-btn:hover{
        background:#3b2d21;
      }

      /* LOGIN */
      .register-login{
        text-align:center;
        margin-top:24px;
        color:#6f6253;
        font-size:14px;
      }

      .register-login a{
        color:#2d241a;
        text-decoration:none;
        border-bottom:1px solid #2d241a;
        padding-bottom:2px;
      }

      /* TERMS */
      .register-terms{
        margin-top:18px;
        font-size:14px;
        color:#8a7863;
        line-height:1.7;
      }

      /* MOBILE */
      @media(max-width:991px){

        .register-container{
          grid-template-columns:1fr;
          gap:30px;
        }

        .register-image img{
          height:500px;
        }
           .register-btn{
        width:50%;
        border-radius:4px;
      }

      }

      @media(max-width:768px){

        .register-page{
          padding-top:90px;
        }

        .register-container{
          padding:20px 18px 50px;
        }

        .register-card{
          padding:35px 24px;
        }

        .register-top h1{
          font-size:30px;
        }

        .double-input{
          grid-template-columns:1fr;
        }

        .register-image img{
          height:360px;
        }

        .image-text{
          left:25px;
          bottom:25px;
        }

        .image-text h2{
          font-size:30px;
        }

      }
        .password-wrapper{
  position:relative;
  margin-bottom:16px;
}

.password-wrapper .register-input{
  margin-bottom:0;
}

.password-toggle{
  position:absolute;
  right:18px;
  top:50%;
  transform:translateY(-50%);
  cursor:pointer;
  color:#777;
  font-size:14px;
}
.register-terms a {
  color: #4c144e;
  text-decoration: underline;
  cursor: pointer;
}

.register-terms a:hover {
  opacity: 0.8;
}
      `}</style>

      <Header />

      <section className="register-page">

        <div className="register-container">

          {/* LEFT */}
          <div className="register-image">

            <img
              src={process.env.PUBLIC_URL + "/images/c12.png"}
              alt=""
            />

            <div className="image-overlay"></div>

            <div className="image-text">
              <span>AETHEARIA</span>

              <h2 style={{textTransform:"capitalize"}}>
                Begin your
                <br />
                ritual journey.
              </h2>
            </div>

          </div>

          {/* RIGHT */}
          <div className="register-card">

            <div className="register-top">

              <span style={{textTransform:"capitalize", fontSize:"14px"}}>Create Account</span>

              <h1 style={{textTransform:"capitalize"}}>Join Aethearia</h1>

              <p style={{textTransform:"capitalize"}}>
                Create your sacred space with timeless rituals,
                soulful products and intentional living.
              </p>

            </div>

            <form className="register-form" onSubmit={handleRegister}>

              <div className="double-input">

               <input
                type="text"
                placeholder="First Name"
                className="register-input"
                value={fname}
                onChange={(e) => setFname(e.target.value)}
              />

                <input
                  type="text"
                  placeholder="Last Name"
                  className="register-input"
                  value={lname}
                  onChange={(e) => setLname(e.target.value)}
                />

              </div>
              <input
                type="email"
                placeholder="Email Address"
                className="register-input"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
              />

              <input
                type="tel"
                placeholder="Phone Number"
                className="register-input"
                value={phone}
                onChange={(e) => setPhone(e.target.value)}
              />

              <div style={{ position: "relative", marginBottom: "16px" }}>
                <input
                  type={showPassword ? "text" : "password"}
                  placeholder="Password"
                  className="register-input"
                  value={password}
                  onChange={(e) => setPassword(e.target.value)}
                  style={{ marginBottom: 0 }}
                />

                <span
                  onClick={() => setShowPassword(!showPassword)}
                  style={{
                    position: "absolute",
                    right: "18px",
                    top: "50%",
                    transform: "translateY(-50%)",
                    cursor: "pointer",
                    color: "#777",
                    fontSize: "18px",
                  }}
                >
                  {showPassword ? <FaEyeSlash /> : <FaEye />}
                </span>
              </div>

              <div style={{ position: "relative", marginBottom: "16px" }}>
                <input
                  type={showConfirmPassword ? "text" : "password"}
                  placeholder="Confirm Password"
                  className="register-input"
                  value={cpassword}
                  onChange={(e) => setCpassword(e.target.value)}
                  style={{ marginBottom: 0 }}
                />

                <span
                  onClick={() => setShowConfirmPassword(!showConfirmPassword)}
                  style={{
                    position: "absolute",
                    right: "18px",
                    top: "50%",
                    transform: "translateY(-50%)",
                    cursor: "pointer",
                    color: "#777",
                    fontSize: "18px",
                  }}
                >
                  {showConfirmPassword ? <FaEyeSlash /> : <FaEye />}
                </span>
              </div>

              <button className="register-btn" disabled={loading}>
                {loading ? "Creating..." : "Create Account"}
              </button>

            </form>

            <div style={{textTransform:"capitalize"}} className="register-login">
              Already have an account?{" "}
              <Link to="/login">
                Sign in
              </Link>
            </div>

            <div style={{ textTransform: "capitalize" }} className="register-terms">
              By creating an account, you agree to our{" "}
              <Link to="/terms-and-conditions">
                Terms & Conditions
              </Link>{" "}
              and{" "}
              <Link to="/privacy-policy">
                Privacy Policy
              </Link>.
            </div>

          </div>

        </div>

      </section>

      <Footer />
    </>
  );
}

export default RegisterPage;